import { CmsApiStickyHeaderLinksGradBlockData } from 'modules/cms/api/types/blocks/CmsApiStickyHeaderLinksGradBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpStickyHeaderLinksGradBlock } from './CmsAmpStickyHeaderLinksGradBlock';
import { CmsStickyHeaderLinksGradBlock } from './CmsStickyHeaderLinksGradBlock';

export const CmsStickyHeaderLinksGradBlockMapping: CmsBlockMapping<CmsApiStickyHeaderLinksGradBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: CmsMappedBlockWidth.FULL,
    Component: CmsStickyHeaderLinksGradBlock,
    AmpComponent: CmsAmpStickyHeaderLinksGradBlock,
  };
